import { ApiService, type ApiRequestConfig } from "./api.service";
import type { IWorkspaceWebhook, IWorkspaceWebhookLog } from "@/types/workspace";

export class WorkspaceWebhookService extends ApiService {
  async listWebhooks(slug: string, config?: ApiRequestConfig): Promise<IWorkspaceWebhook[]> {
    return this.get(`/api/workspaces/${slug}/webhooks/`, config);
  }

  async getWebhook(
    slug: string,
    webhookId: string,
    config?: ApiRequestConfig,
  ): Promise<IWorkspaceWebhook> {
    return this.get(`/api/workspaces/${slug}/webhooks/${webhookId}/`, config);
  }

  async createWebhook(slug: string, data: Partial<IWorkspaceWebhook>): Promise<IWorkspaceWebhook> {
    return this.post(`/api/workspaces/${slug}/webhooks/`, data);
  }

  async updateWebhook(
    slug: string,
    webhookId: string,
    data: Partial<IWorkspaceWebhook>,
  ): Promise<IWorkspaceWebhook> {
    return this.patch(`/api/workspaces/${slug}/webhooks/${webhookId}/`, data);
  }

  async deleteWebhook(slug: string, webhookId: string): Promise<void> {
    return this.delete(`/api/workspaces/${slug}/webhooks/${webhookId}/`);
  }

  async regenerateSecret(slug: string, webhookId: string): Promise<IWorkspaceWebhook> {
    return this.post(`/api/workspaces/${slug}/webhooks/${webhookId}/regenerate/`);
  }

  async listLogs(
    slug: string,
    webhookId: string,
    config?: ApiRequestConfig,
  ): Promise<IWorkspaceWebhookLog[]> {
    return this.get(`/api/workspaces/${slug}/webhook-logs/${webhookId}/`, config);
  }
}
